var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "yxt-input",
    _vm._g(
      _vm._b(
        {
          attrs: {
            placeholder: _vm.$t("pc_biz_enterName" /* 请输入直播名称 */),
            maxlength: "50",
            "show-word-limit": "",
          },
          model: {
            value: _vm.getValue,
            callback: function ($$v) {
              _vm.getValue = $$v
            },
            expression: "getValue",
          },
        },
        "yxt-input",
        _vm.$attrs.attrs,
        false
      ),
      _vm.$attrs.on
    )
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }